export default {
  // Commun
  common: {
    back: 'Retour',
    confirm: 'Confirmer',
    continue: 'Continuer',
    cancel: 'Annuler',
    retry: 'Réessayer',
    total: 'Total',
    profile: 'Profil',
    history: 'Historique',
    pleaseLogin: 'Veuillez vous connecter',
    my: 'Moi',
    appName: 'Menu IA',
    loading: 'Chargement...',
    lang: "Choisir la langue",
    loadFailed: 'Échec du chargement',
    operationFailed: 'Opération échouée',
    notSet: 'Non défini',
    country: 'Pays',
    all: 'Tout',
    searchPlaceholder: 'Rechercher',
    noMore: 'Rien de plus'
  },

  // Accueil
  home: {
    allFoods: 'Tous les plats',
    headline: {
      sub: 'Découvrez',
      main: 'Cuisine {country}'
    },
    articleTag: 'Guide',
    localGuideTitle: 'Guide local',
    recommendedArticlesAll: 'Tout',
    hotTopics: 'Sujets populaires',
    orderCallout: 'Fini les commandes "this, this" !',
    mustEatBadge: 'À goûter',
    countrySelect: {
      eyebrow: 'Destination',
      title: 'Sélectionnez le pays',
      subtitle: 'Pour des inspirations et guides culinaires adaptés',
      footer: 'Modifiable à tout moment en haut à gauche'
    },
    loadCountriesFailed: 'Échec du chargement des pays'
  },

  // Favoris
  favorites: {
    title: 'Favoris',
    empty: 'Aucun favori',
    foods: 'Plats',
    articles: 'Guides'
  },

  articleList: {
    title: 'Guides {country}',
    empty: 'Aucun guide recommandé'
  },

  // Détail du plat
  dishDetail: {
    quantity: 'Quantité',
    introduction: 'Description',
    loadingIntroduction: 'Chargement de la description...',
    getIntroduction: 'Voir la description',
    addToCart: 'Ajouter au panier ({count} portions)',
    selectQuantity: 'Sélectionnez la quantité',
    addedToCart: '{count} portions ajoutées au panier',
    loadFailed: 'Échec du chargement de la description',
    noImage: 'Aucune image',
    imageSearchEmpty: 'Aucune image précise du plat trouvée',
    imageSearchAction: 'Rechercher des images',
    aiImageGenerating: 'Génération d\'image IA en cours',
    generating: 'Génération en cours'
  },

  // Barre d'onglets
  tabbar: {
    home: 'Accueil',
    cameraOrder: 'Photo & Commande',
    favorites: 'Favoris',
    profile: 'Moi',
    camera: 'Photo',
    menu: 'Menu'
  },

  // Caméra
  camera: {
    translate: 'Traduire en',
    takeOrUpload: 'Prendre une photo ou télécharger',
    uploadHint: 'Plusieurs photos supportées (max 9)',
    addMore: 'Ajouter plus',
    order: 'Commencer la commande',
    selectLanguage: 'Langue de traduction',
    singleMode: 'Mode simple',
    multiMode: 'Mode multiple',
    history: 'Historique',
    takePhotoError: 'Échec de la photo, veuillez réessayer',
    cameraUnsupported: 'Appareil photo non supporté',
    cameraPermissionDenied: 'Accès à la caméra refusé, veuillez l\'activer dans les paramètres',
    capture: 'Continuer à photographier',
    tapToCapture: 'Appuyer pour photographier',
    tapToStart: 'Appuyer pour commencer',
    readyToCapture: 'Photographier le menu',
    uploading: 'Envoi en cours...',
    uploadFailed: 'Échec de l\'envoi',
    pleaseCapture: 'Veuillez d\'abord prendre une photo',
    maxPhotosReached: 'Maximum de 9 photos atteint',
    photosAdded: '{count} photos ajoutées',
    confirmUpload: 'Confirmer l\'envoi',
    uploadMessage: 'Envoi de {count} photos pour analyse du menu',
    startRecognition: 'Lancer l\'analyse',
    confirmRecognition: 'Confirmer l\'analyse',
    willRecognize: 'Analyse de {count} photos de menu',
    continueShooting: 'Continuer à photographier',
    prepareUpload: 'Préparation de l\'envoi...',
    compressingImage: 'Compression de l\'image...',
    compressionFailed: 'Échec de la compression',
    useOriginal: 'Utiliser l\'original',
    takePhoto: 'Prendre une photo',
    selectFromGallery: 'Choisir depuis la galerie',
    operationFailed: 'Opération échouée, veuillez réessayer',
    processingPhoto: 'Traitement de la photo...',
    leavingPageWarning: 'Traitement en cours, voulez-vous vraiment quitter ?',
    restoreInfoMissing: '{count} photos détectées mais données manquantes, veuillez reprendre les photos',
    addedAndSkipped: '{added} ajoutées, {skipped} fichiers non-image ignorés',
    remainingQuotaNotice: 'Cher utilisateur {phone} : Validité de l\'abonnement : {days}',
    guide: {
      step1: 'Photographier',
      step2: 'Analyse IA',
      step3: 'Menu généré'
    }
  },

  // Connexion
  login: {
    title: 'Connexion',
    phone: 'Téléphone',
    code: 'Code',
    phoneNumber: 'Numéro de téléphone',
    verifyCode: 'Code de vérification',
    sendCode: 'Envoyer le code',
    resend: 'Renvoyer',
    login: 'Se connecter',
    loggingIn: 'Connexion...',
    success: 'Connexion réussie',
    failed: 'La connexion a expiré, veuillez réessayer plus tard',
    loginSuccess: 'Connexion réussie',
    loginFailed: 'Échec de la connexion',
    phonePlaceholder: 'Entrez votre numéro',
    codePlaceholder: 'Entrez le code',
    phoneRequired: 'Numéro requis',
    codeRequired: 'Code requis',
    phoneInvalid: 'Format du numéro invalide',
    codeInvalid: 'Le code doit comporter 4 à 6 chiffres',
    phoneError: 'Format du numéro incorrect',
    codeError: 'Format du code incorrect',
    codeSent: 'Code envoyé',
    resendCode: 'Renvoyer',
    countdown: 'Réessayer dans {count}s',
    retryAfter: 'Réessayer dans {seconds}s',
    tooFrequent: 'Trop fréquent, veuillez réessayer plus tard',
    dailyLimit: 'Limite quotidienne atteinte',
    sendFailed: 'Échec de l\'envoi, veuillez réessayer plus tard',
    agreeTips: 'En vous connectant, vous acceptez les conditions d\'utilisation et la politique de confidentialité'
  },

  // Menu
  menu: {
    title: 'Menu',
    cartTitle: 'Panier',
    checkout: 'Commander',
    totalItems: '{count} articles',
    clearCart: 'Vider le panier',
    emptyCart: 'Le panier est vide',
    aiRecommend: 'Recommandation IA',
    addToCart: 'Ajouter',
    viewDetail: 'Détails',
    price: 'Prix',
    quantity: 'Quantité',
    currentMenu: 'Menu actuel',
    clearCartConfirm: 'Voulez-vous vraiment vider le panier ?',
    noMenuData: 'Veuillez d\'abord photographier le menu',
    confirmButton: 'Confirmer',
    cancelButton: 'Annuler',
    hint: 'Indication',
    noMenuItemsFound: 'Aucun élément de menu identifié',
  },

  // IA
  ai: {
    recommendedSets: 'Menus recommandés',
    dishCount: 'plats',
    selectSetHint: 'Veuillez choisir un menu recommandé',
    noSelectedDishes: 'Veuillez d\'abord choisir des plats',
    setPrefix: 'Menu',
    others: 'Autres',
    diningOptions: 'Préférences de repas',
    numberOfPeople: 'Nombre de personnes',
    dietaryPreferences: 'Préférences alimentaires',
    budgetRange: 'Budget',
    getRecommendation: 'L\'IA commande pour moi',
    noSpicy: 'Pas épicé',
    vegetarian: 'Végétarien',
    seafood: 'Fruits de mer',
    meat: 'Viande',
    loading: 'Génération des recommandations...',
    recommendationTitle: 'Recommandation IA',
    tastePreference: 'Goûts',
    budgetPerPerson: 'Budget par personne',
    allergyWarning: 'Restrictions alimentaires (Allergènes)',
    sweet: 'Sucré',
    sour: 'Acide',
    spicy: 'Épicé',
    bitter: 'Amer',
    umami: 'Umami',
    light: 'Léger',
    heavy: 'Riche',
    dairy: 'Produits laitiers',
    eggs: 'Œufs',
    fish: 'Poisson',
    shellfish: 'Crustacés',
    treeNuts: 'Fruits à coque',
    peanuts: 'Arachides',
    wheat: 'Blé',
    soy: 'Soja',
    selectOptions: 'Veuillez sélectionner vos préférences',
    peopleCountError: 'Le nombre de personnes doit être d\'au moins 1',
    budgetRangeError: 'Le budget doit être un entier positif',
    budgetMaxMinError: 'Le budget maximum doit être supérieur ou égal au minimum',
    submitFailed: 'Échec de la soumission, veuillez réessayer',
    minBudget: 'Budget min',
    maxBudget: 'Budget max',
    to: 'à',
    yuan: 'CNY',
    recommendProgress: 'Progression IA',
    analyzing: 'Analyse du menu...',
    generating: 'Génération du plan...',
    recommendReason: 'Raison',
    menuCombination: 'Composition du menu',
    dietaryNotes: 'Conseils diététiques',
    servingSize: 'Portions suggérées',
    viewDetail: 'Détails',
    goToCheckout: 'Commander',
    dish: 'portion(s)',
    menuOption: 'Menu',
    recommendedDishes: 'Plats recommandés',
    categoryDishes: 'Plats par catégorie',
    order: 'Commander',
    orderConversation: 'Dialogue de commande'
  },

  // Upload
  upload: {
    title: 'Analyse en cours',
    uploading: 'Envoi...',
    recognizing: 'Reconnaissance du menu...',
    translating: 'Traduction...',
    generating: 'Génération des résultats...',
    complete: 'Terminé',
    failed: 'Échec',
    progress: 'Progression',
    detailsTitle: 'Détails de l\'analyse',
    retake: 'Reprendre',
    retryUpload: 'Réessayer l\'envoi',
    buyBenefits: 'Mettre à niveau',
    uploadingNow: 'Envoi en cours',
    aiRecognizingImages: 'L\'IA analyse les images',
    aiTranslatingMenu: 'L\'IA traduit le menu',
    dynamicCompression: 'Compression dynamique des images',
    ocrEngineIntegration: 'Intégration du moteur OCR',
    agentEngineBoot: 'Démarrage du moteur d\'agent',
    llmContextParsing: 'Analyse contextuelle LLM',
    ragTargetLanguage: 'Correspondance langue cible RAG',
    cuisineRegionMapping: 'Cartographie cuisine/région',
    enhancedTranslation: 'Traduction améliorée activée',
    dishMetadataClassification: 'Classification des métadonnées des plats',
    semanticUiConstruction: 'Construction UI sémantique',
    confirmCancelTitle: 'Confirmer l\'annulation',
    confirmCancelMessage: 'Voulez-vous vraiment annuler l\'analyse ?',
    preparingCount: 'Préparation de {count} photos...',
    startUploadCount: 'Démarrage de l\'envoi de {count} photos',
    processingComplete: 'Traitement terminé',
    navigatingSoon: 'Redirection imminente...',
    processingCompleteAndNavigate: 'Traitement terminé, redirection...',
    createBackgroundTask: 'Création de la tâche en arrière-plan...',
    noPhotoFound: 'Aucune photo trouvée',
    pleaseRetake: 'Veuillez reprendre les photos',
    dataParseFailed: 'Échec de l\'analyse des données',
    photoDataParseFailed: 'Échec de l\'analyse des données photo',
    photoDataFormatError: 'Format de données photo incorrect, veuillez reprendre',
    uploadFailedShort: 'Échec de l\'envoi',
    failedShort: 'Échec',
    errorTryAgain: 'Traitement échoué, veuillez réessayer',
    menuNotFound: 'Menu non reconnu, veuillez reprendre la photo',
    otherLlmErr: 'Échec de la traduction du menu',
    finalizing: 'Finalisation de la traduction...',
    almostDone: 'Presque terminé, veuillez patienter'
  },

  // Erreurs
  error: {
    network: 'Erreur réseau, veuillez vérifier votre connexion',
    server: 'Erreur serveur, veuillez réessayer plus tard',
    timeout: 'Délai d\'attente dépassé, veuillez réessayer',
    unknown: 'Erreur inconnue',
    auth: 'Authentification échouée, veuillez vous reconnecter',
    selectImage: 'Veuillez sélectionner une image',
    imageTooLarge: 'L\'image ne doit pas dépasser 20MB',
    processPhotoFailed: 'Échec du traitement de la photo, veuillez réessayer',
    processFileFailed: 'Échec du traitement du fichier',
    pageStateError: 'Anomalie de la page, veuillez reprendre la photo',
    processingPhotos: 'Traitement des photos en cours, veuillez patienter...',
    livePhotoNotSupported: 'Veuillez choisir une photo standard, Live Photo non supporté',
    microphonePermissionDenied: 'Accès au microphone refusé, veuillez l\'autoriser dans les paramètres',
    microphoneNotFound: 'Microphone non trouvé',
    microphoneInUse: 'Le microphone est utilisé par une autre application',
    microphoneConfigNotSupported: 'Le microphone ne supporte pas la configuration demandée',
    recordingNotSupported: 'Le navigateur ne supporte pas l\'enregistrement',
    recordingError: 'Erreur pendant l\'enregistrement',
    forbidden: 'Accès refusé',
    notFound: 'Ressource non trouvée',
    requestFailed: 'Requête échouée',
    configError: 'Erreur de configuration'
  },

  // Dialogue de commande
  orderConversation: {
    title: 'Dialogue de commande',
    menu_order: "Commande",
    quantity: 'Quantité',
    translatedText: 'Traduction',
    orderText: 'Texte de commande',
    userSpeak: 'Maintenir pour parler',
    waiterSpeak: 'Maintenir pour parler',
    customerSpeak: 'Maintenir pour parler',
    waiterSpec: "Serveur",
    customerSpec: "Client",
    dish_detail: "Détails",
    recording: 'Enregistrement...',
    common_confirm: 'Confirmer',
    customerRecording: 'Le client parle...',
    recognizing: 'Reconnaissance...',
    translating: 'Traduction...',
    recordingFailed: 'Échec de l\'enregistrement, vérifiez le microphone',
    recognitionFailed: 'Échec de la reconnaissance vocale',
    translationFailed: 'Échec de la traduction',
    recognitionResult: 'Résultat',
    blankAudio: "Audio trop court",
    noDishes: 'Aucun plat sélectionné',
    assistantIntro: 'Bonjour, je suis l\'assistant de commande du client. Le client souhaite commander les plats suivants. Si vous avez des questions, maintenez le bouton en bas pour parler, je traduirai.'
  },

  // Profil
  profile: {
    title: 'Moi',
    memberCard: {
      title: 'Avantages Membre',
      dynamicTitle: 'Vous êtes actuellement un utilisateur {status}<br />Avantages inclus :',
      feature1: ' Reconnaissance précise du menu',
      feature2: ' Traduction en 20+ langues',
      feature3: ' Recommandation IA',
      feature4: ' Introduction aux plats internationaux',
      feature5: ' Traduction vocale continue',
      featureUsageTemplate: '{feature} ({count})',
      unlock: 'Débloquer maintenant',
      unlockBenefits: 'Mettre à niveau les avantages'
    },
    menu: {
      privacy: 'Confidentialité',
      terms: 'Conditions d\'utilisation',
      feedback: 'Feedback',
      serviceStatus: 'État du service',
      about: 'À propos'
    },
    redeem: {
      button: 'Échanger Code',
      title: 'Échange de Code',
      description: 'Veuillez entrer le code d\'échange pour activer les avantages.',
      placeholder: 'Entrer le code',
      helper: 'Lettres A-Z et chiffres 0-9 acceptés. Les espaces sont ignorés et la casse ne compte pas.',
      submit: 'Échanger',
      cancel: 'Annuler',
      success: 'Échange réussi, avantages mis à jour',
      validation: {
        empty: 'Veuillez entrer le code',
        length: 'Le code doit contenir 12 caractères avec lettres et chiffres',
        format: 'Format du code incorrect, veuillez vérifier',
        checksum: 'Échec de la vérification du code, veuillez confirmer et réessayer'
      }
    },
    register: 'Supprimer le compte',
    registerHint: 'Fonctionnalité en cours de développement',
    logout: 'Déconnexion',
    logoutConfirm: {
      title: 'Déconnexion',
      message: 'Êtes-vous sûr de vouloir vous déconnecter ?'
    },
    logoutSuccess: 'Déconnecté avec succès'
  },

  subscription: {
    subtitle: 'AI MENU PASS',
    title: 'Débloquez les avantages AI Menu',
    columns: {
      feature: 'Comparaison'
    },
    plans: {
      freeUser: 'Utilisateur Gratuit',
      trial: 'Essai Gratuit',
      trialTag: 'Essai Limité',
      oneDay: 'Pass 1 Jour',
      twoDay: 'Pass 2 Jours',
      threeDay: 'Pass 3 Jours',
      fiveDay: 'Pass 5 Jours'
    },
    actions: {
      tryNow: 'Essayer',
      purchase: 'Acheter',
      continueTrial: 'Continuer l\'essai',
      trialUnavailable: 'Essai terminé',
      renew: 'Renouveler',
      subscribed: 'Abonné'
    },
    features: {
      validity: 'Validité restante',
      price: 'Prix',
      usageCount: 'Utilisations',
      aiTranslate: 'Traduction Menu IA',
      aiTextDetail: 'Détails Plats (Texte)',
      aiRecommend: 'Recommandation IA',
      aiOrder: 'Aide à la commande IA',
      aiVoice: 'Traduction vocale'
    },
    values: {
      days: '{count} jours',
      lifetime: 'À vie',
      free: '0',
      price: '{amount} CNY',
      times: '{count} fois',
      notAvailable: '-',
      comingSoon: '- (Bientôt disponible)'
    },
    remarkTitle: 'Note',
    remarksText:
      '1. Pays couverts pour la traduction de menus : Asie : Japon, Corée du Sud, Thaïlande, Vietnam, Singapour, Malaisie, Indonésie, EAU, Turquie ; Europe : Royaume-Uni, France, Allemagne, Autriche, Suisse, Italie, Irlande, Espagne, Portugal, Russie, Tchéquie, Hongrie, Croatie, Pays-Bas, Roumanie, Suède ; Amérique du Nord : USA, Canada, Mexique ; Amérique du Sud : Brésil, Argentine, Chili, Uruguay, Paraguay, Colombie, Venezuela, Panama, Pérou, Équateur ; Autres : Australie, Nouvelle-Zélande.' +
      '\nRemarque : La Suisse supporte l\'allemand, le français et l\'italien ; l\'Autriche supporte uniquement l\'allemand ; L\'Amérique du Sud (sauf Brésil) supporte l\'espagnol.' +
      '\n2. L\'entreprise se réserve le droit d\'interpréter le contenu et les règles de cette page, conformément aux lois et réglementations pour protéger les droits des utilisateurs.',
    toast: {
      trialRedirect: 'Redirection pour activer l\'expérience complète',
      purchaseRedirect: 'Redirection pour l\'achat',
      contactAdmin: 'Veuillez contacter l\'administrateur pour activer le service membre',
      noQuota: 'Vous avez atteint la limite d\'utilisation, veuillez acheter des avantages dans la page "Moi"',
      subscriptionExpired: 'Votre abonnement a expiré ou la limite est atteinte, veuillez renouveler dans la page "Moi"',
      trialExhausted: 'Votre essai est terminé, veuillez acheter un abonnement dans la page "Moi"',
      wechatRequired: 'Veuillez utiliser le navigateur intégré WeChat pour le paiement',
      paySuccess: 'Paiement réussi, avantages mis à jour',
      payCancelled: 'Paiement annulé',
      payFailed: 'Paiement échoué, veuillez réessayer plus tard',
      payPending: 'Le paiement est en cours de confirmation. Vérifiez le statut de la commande plus tard',
      productUnavailable: 'Ce produit n\'est pas disponible pour le moment, veuillez réessayer plus tard'
    },
    currentBenefits: 'Plan actuel',
    moreDetails: 'Détails',
    remainingBenefits: 'Restant',
    totalBenefits: 'Total',
    expireTime: 'Date d\'expiration',
    tabs: {
      compare: 'Comparer',
      detail: 'Détails'
    },
    upgradeTitle: 'Mettre à niveau',
    trialNoteTitle: 'Note d\'essai',
    trialNoteText: 'Les membres en essai peuvent essayer la traduction du menu et d\'autres fonctionnalités. L\'essai n\'affecte pas les avantages de l\'abonnement.',
    statusDetail: {
      title: 'Détails du plan',
      planName: 'Nom du plan',
      startTime: 'Date de début',
      expireTime: 'Date de fin',
      totalCount: 'Total',
      status: 'Statut',
      statusMap: {
        pending: 'En attente',
        active: 'Actif',
        invalid: 'Invalide/Expiré'
      }
    },
    durations: {
      oneDay: '1 jour',
      twoDay: '2 jours',
      threeDay: '3 jours',
      fiveDay: '5 jours'
    },
    subscriptionSuffix: 'Abonnement',
    subscriptionName: 'Abonnement {duration}',
    fiveDayDesc: 'Validité de 5 jours',
    validityOnly: 'Validité {duration}',
    validityAndUsage: 'Validité {duration}, inclut {usage} utilisations',
    usageCountSimple: 'Utilisations'
  }
}
